import React, { useCallback } from 'react';

import { useBatchAddPromoCode } from 'scenes/Campaigns/GGCampaigns/data/mutations';
import { loadPromoCodesBulk } from 'scenes/Campaigns/sources/campaigns';
import { AddPromoCodeForm } from 'scenes/PromoCodes/components/AddPromoCodeForm';

const CampaignsAddPromoCodeForm = ({
  initialValues,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [batchAddPromoCode, { isLoading }] = useBatchAddPromoCode();

  const handleSubmit = useCallback(async ({ ids, promoCodeId }) => {
    await batchAddPromoCode({
      goGameCampaignsIds: ids,
      id: promoCodeId,
    });
    onSubmit();
  }, []);

  return (
    <AddPromoCodeForm
      title={'GG Campaigns'}
      initialValues={initialValues}
      loading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      onLoadPromoCodes={() =>
        loadPromoCodesBulk({ ggCampaignsIds: initialValues.ids })
      }
    />
  );
};
export default CampaignsAddPromoCodeForm;
